export const isOpenSection = (openedSectionId: string[], sectionId: string) => {
  return openedSectionId.includes(sectionId);
};
